"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
/**
 * Set the source initializing state
 *
 * @param {string} sourceIdOrValue - The source id or value
 * @param {object} options - The initializing state
 *
 * @returns {function} - The thunk
 **/
function setSourceInitializing(sourceIdOrValue, _ref) {
  var _ref$isInitializing = _ref.isInitializing,
    isInitializing = _ref$isInitializing === void 0 ? false : _ref$isInitializing;
  return function (dispatch, getState) {
    var state = getState();
    var sources = state.broadcastSources.sources;
    var sourceToUpdate = sourceIdOrValue;
    var shouldInitializeSource = true;
    var source = sources.find(function (src) {
      return src.value === sourceIdOrValue;
    });
    if (!source) {
      return;
    }
    sourceToUpdate = source._id;
    shouldInitializeSource = source.isInitializing !== isInitializing;
    if (shouldInitializeSource) {
      var payload = {
        sourceId: sourceToUpdate,
        isInitializing: isInitializing
      };
      dispatch({
        type: _types.BROADCAST_INITIALIZING_SOURCE,
        payload: payload
      });
    }
    return true;
  };
}
var _default = exports["default"] = setSourceInitializing;